import { Component } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { BaseComponent, LanguageService, TranslatedToastrService, ValidationHandlerService } from 'lib/Vestra.shared';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { CouponFilterType } from '../../services/api-services';

@Component({
    selector: 'app-coupon-tabpage',
    templateUrl: './coupon-tabpage.component.html',
    styleUrl: './coupon-tabpage.component.scss',
    standalone: false,
})
export class CouponTabpageComponent extends BaseComponent {
    public userId: string;

    private _activeTab: number = 0;
    get activeTab() {
        return this._activeTab;
    }
    set activeTab(value: number) {
        this._activeTab = value;
    }

    public isLargeScreen: boolean = false;
    private subscription: Subscription;

    get allFilter(): CouponFilterType {
        return CouponFilterType.All;
    }
    get weeklyTopFilter(): CouponFilterType {
        return CouponFilterType.WeeklyTop;
    }
    get carouselFilter(): CouponFilterType {
        return CouponFilterType.Carousel;
    }

    constructor(
        protected override validationHandlerService: ValidationHandlerService,
        protected override modalService: BsModalService,
        private translatedToastrService: TranslatedToastrService,
        private route: ActivatedRoute,
        private router: Router,
        protected override spinnerService: NgxSpinnerService,
        protected translateService: TranslateService,
        protected override languageService: LanguageService,
        private responsive: BreakpointObserver
    ) {
        super(spinnerService, modalService, validationHandlerService);
    }

    public ngOnInit() {
        this.subscription = this.responsive.observe(Breakpoints.WebLandscape).subscribe(result => {
            this.isLargeScreen = false;

            if (result.matches) {
                this.isLargeScreen = true;
            }
        });
    }

    public ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    public onSwipe(event: any) {
        if (this.isLargeScreen) {
            return;
        }

        const currentIndex = this.activeTab;
        if (event.deltaX < 0 && currentIndex < 4) {
            this.activeTab++;
        } else if (event.deltaX > 0 && currentIndex > 1) {
            this.activeTab--;
        } else {
            return;
        }
    }

    public navigateToTab(index: number): void {
        this.activeTab = index;
    }
}
